import script from "./SiteNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteNavigation.vue?vue&type=script&setup=true&lang=js"

import "./SiteNavigation.vue?vue&type=style&index=0&id=0d4c9c7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d4c9c7c"]])

export default __exports__